import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter046() {
  return <KbChapterPage slug="chapter-046" />;
}

(Chapter046 as unknown as { path: string }).path = "/theory-album/046";
